import React, { FC } from 'react';

import { colors } from '@constants/colors';
import { CustomModal } from '@components';
import { translate, translateDynamic } from '@utils/locale';

import { DeleteInvestorModalPropsType } from './types';
import { InvestorType } from '../../constants';

const DeleteInvestorModal: FC<DeleteInvestorModalPropsType> = ({
  handleCancelClick,
  investorName,
  isModalOpen,
  isDeleteLoading,
  onClickDeleteInvestor,
  investorType
}) => {
  return (
    <div>
      <CustomModal
        isModalOpen={isModalOpen}
        customStyle={'!text-left px-6'}
        header={translateDynamic('company.deleteInvestor.title', {
          investorName: investorName
        })}
        primaryButtonLabel={translate(
          'modals.deleteconfirmationModalConfirmButtonTitle'
        )}
        secondaryButtonVariant="outlined"
        secondaryButtonLabel={translate('company.deleteInvestor.dontDelete')}
        body={
          <div className="py-9 px-6 text-base font-normal text-gray-500 border-y-2 border-gray-100">
            {translate('company.deleteInvestor.removeUserInvite', {
              type:
                investorType === InvestorType.InstitutionalInvestor
                  ? 'Institutional'
                  : 'Angel'
            })}
          </div>
        }
        primaryButtonCustomStyle={{
          backgroundColor: colors.warningRed
        }}
        onChangePrimaryButton={onClickDeleteInvestor}
        onChangeSecondaryButton={handleCancelClick}
        width={445}
        paddingLeft={0}
        paddingRight={0}
        customButtonContainerStyles="px-6 justify-end pt-4"
        isPrimaryButtonLoading={isDeleteLoading}
      />
    </div>
  );
};

export default DeleteInvestorModal;
